/* r26-collection: filters B2.1 (client and server modes), mobile sheet, end tile, guide tabs, quiz (mockups 25/10).
   The photo view toggle (data-view) and the sort select (data-sort) stay handled by rashu.js. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var lay = $("[data-cf]");
  var aside = $("#cf-filtres");
  var desk = window.matchMedia("(min-width: 1024px)");

  /* ---------- filter groups open / close ---------- */
  $$(".cf-as .gp-t").forEach(function (b) {
    b.addEventListener("click", function () {
      var gp = b.closest(".gp"); var shut = gp.classList.toggle("shut");
      b.setAttribute("aria-expanded", shut ? "false" : "true");
    });
  });

  /* ---------- mobile bottom sheet ---------- */
  var mbtn = $(".cf-mbtn"), scrim = $(".cf-scrim"), lastFocus = null;
  function sheet(on) {
    if (!aside) return;
    aside.classList.toggle("on", on);
    if (scrim) scrim.hidden = !on;
    if (mbtn) mbtn.setAttribute("aria-expanded", on ? "true" : "false");
    document.documentElement.style.overflow = on ? "hidden" : "";
    if (on) { lastFocus = document.activeElement; var x = $(".as-x", aside); if (x) x.focus(); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (mbtn) mbtn.addEventListener("click", function () { sheet(true); });
  if (scrim) scrim.addEventListener("click", function () { sheet(false); });
  $$(".as-x").forEach(function (b) { b.addEventListener("click", function () { sheet(false); }); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && aside && aside.classList.contains("on")) sheet(false); });
  desk.addEventListener && desk.addEventListener("change", function (e) { if (e.matches) sheet(false); });
  // The floating button only shows while the grid is on screen
  if (mbtn && lay && "IntersectionObserver" in window) {
    new IntersectionObserver(function (en) { mbtn.classList.toggle("off", !en[0].isIntersecting); }, { rootMargin: "0px 0px -120px 0px" }).observe(lay);
  }

  /* ---------- server mode: desktop submits on change, mobile waits for « Voir les résultats » ---------- */
  var sform = $("form[data-cf-server]");
  if (sform) {
    sform.addEventListener("change", function (e) {
      if (desk.matches && e.target.matches("input[type=checkbox]")) sform.requestSubmit ? sform.requestSubmit() : sform.submit();
    });
  }

  /* ---------- end-of-grid tile span (fills the last row) ---------- */
  var grid = $(".cf-g"), tile = $(".cf-tile");
  function fitTile(n) {
    if (!tile) return;
    var sd = n % 3 === 0 ? 3 : 3 - (n % 3), sm = n % 2 === 0 ? 2 : 1;
    tile.style.setProperty("--sd", sd); tile.style.setProperty("--sm", sm);
    tile.classList.toggle("narrow", sd === 1);
    tile.hidden = n === 0;
  }

  /* ---------- client mode: instant filters ---------- */
  var client = lay && lay.hasAttribute("data-client");
  var items = $$(".cf-it[data-manches]");
  var state = {};
  var GROUPS = ["manches", "pour", "piece", "couleur", "univers", "size"];
  function attr(g) { return g === "size" ? "data-size" : "data-" + g; }
  function match(it, skip) {
    for (var i = 0; i < GROUPS.length; i++) {
      var g = GROUPS[i]; if (g === skip) continue;
      var on = state[g]; if (!on || !on.length) continue;
      var v = it.getAttribute(attr(g)) || "";
      if (!on.some(function (x) { return v.indexOf("|" + x + "|") > -1; })) return false;
    }
    return true;
  }
  function label(n) { return n + (n > 1 ? " pièces" : " pièce"); }
  function render() {
    var n = 0;
    items.forEach(function (it) { var ok = match(it); it.hidden = !ok; if (ok) n++; });
    // faceted counts: each value counted against the other groups
    $$(".cf-as .gp[data-g]").forEach(function (gp) {
      var g = gp.getAttribute("data-g");
      $$(".cb[data-v]", gp).forEach(function (b) {
        var v = b.getAttribute("data-v"), c = 0;
        items.forEach(function (it) { if (match(it, g) && (it.getAttribute(attr(g)) || "").indexOf("|" + v + "|") > -1) c++; });
        var em = $("em", b); if (em) em.textContent = c;
        b.classList.toggle("is-zero", c === 0 && b.getAttribute("aria-checked") !== "true");
        b.setAttribute("aria-checked", (state[g] || []).indexOf(v) > -1 ? "true" : "false");
      });
      $$(".szs button[data-s]", gp).forEach(function (b) {
        var s = b.getAttribute("data-s"), c = 0;
        items.forEach(function (it) { if (match(it, "size") && (it.getAttribute("data-size") || "").indexOf("|" + s + "|") > -1) c++; });
        var on = (state.size || []).indexOf(s) > -1;
        b.setAttribute("aria-pressed", on ? "true" : "false");
        b.classList.toggle("zero", c === 0 && !on);
      });
    });
    // count, active chips, buttons
    var act = $(".cf-act");
    if (act) {
      var html = '<span class="cnt"><b>' + n + "</b> " + (n > 1 ? "pièces" : "pièce") + "</span>", any = 0;
      GROUPS.forEach(function (g) {
        (state[g] || []).forEach(function (v) {
          any++;
          html += '<button type="button" data-rm="' + g + "|" + v.replace(/"/g, "&quot;") + '" aria-label="Retirer ' + v.replace(/"/g, "&quot;") + '">' + (g === "size" ? "Taille " : "") + v.replace(/</g, "&lt;") + '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
        });
      });
      if (any) html += '<button type="button" class="clr" data-rm="*">Tout effacer</button>';
      act.innerHTML = html;
      var b = $(".cf-mbtn b"); if (b) b.textContent = any ? any : "";
    }
    $$(".as-go").forEach(function (b) { b.textContent = "Voir " + label(n); });
    var empty = $(".cf-empty"); if (empty) empty.hidden = n > 0;
    fitTile(n ? n + ($(".cf-g > .edito") ? 2 : 0) : 0);
    // hash state, shareable
    var parts = [];
    GROUPS.forEach(function (g) { if (state[g] && state[g].length) parts.push(g + ":" + state[g].map(encodeURIComponent).join(",")); });
    var h = parts.length ? "#f=" + parts.join(";") : "";
    if (h !== location.hash && (h || location.hash.indexOf("#f=") === 0)) history.replaceState(null, "", location.pathname + location.search + h);
  }
  function toggle(g, v) {
    var a = state[g] || (state[g] = []); var i = a.indexOf(v);
    if (i > -1) a.splice(i, 1); else a.push(v);
    render();
  }
  function clearAll() { state = {}; render(); }
  function setFilter(f) { state = {}; Object.keys(f || {}).forEach(function (g) { state[g] = [].concat(f[g]); }); render(); }

  function readHash() {
    if (location.hash.indexOf("#f=") !== 0) return false;
    state = {};
    location.hash.slice(3).split(";").forEach(function (p) {
      var k = p.split(":"); if (GROUPS.indexOf(k[0]) > -1 && k[1]) state[k[0]] = k[1].split(",").map(decodeURIComponent);
    });
    return true;
  }
  if (client && items.length) {
    readHash();
    // links like href="#f=manches:Longues" (guide tiles) filter the grid in place
    // same hash clicked twice (quiz result, comparison) fires no hashchange: apply it by hand
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="#f="]'); if (!a) return;
      e.preventDefault();
      history.replaceState(null, "", location.pathname + location.search + a.getAttribute("href"));
      if (readHash()) { render(); if (lay) lay.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
    window.addEventListener("hashchange", function () {
      if (readHash()) { render(); if (lay) lay.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
    $$(".cf-as .gp[data-g] .cb[data-v]").forEach(function (b) {
      b.addEventListener("click", function () { toggle(b.closest(".gp").getAttribute("data-g"), b.getAttribute("data-v")); });
    });
    $$(".cf-as .szs button[data-s]").forEach(function (b) {
      b.addEventListener("click", function () { toggle("size", b.getAttribute("data-s")); });
    });
    document.addEventListener("click", function (e) {
      var rm = e.target.closest("[data-rm]");
      if (rm) { var k = rm.getAttribute("data-rm"); if (k === "*") clearAll(); else { var i = k.indexOf("|"); toggle(k.slice(0, i), k.slice(i + 1)); } return; }
      if (e.target.closest(".as-clr")) { clearAll(); return; }
      if (e.target.closest(".as-go")) { sheet(false); if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
    render();
  }

  /* highlight one product of the grid (quiz result, guide zoom) */
  function show(handle, filter) {
    if (client && filter) setFilter(filter);
    var it = handle && $('.cf-it[data-h="' + handle + '"]');
    if (it && it.hidden && client) { clearAll(); }
    var target = it || grid;
    if (!target) return;
    var card = it ? (it.firstElementChild || it) : grid;
    card.scrollIntoView({ behavior: "smooth", block: "center" });
    if (it) { it.classList.add("hl"); setTimeout(function () { it.classList.remove("hl"); }, 2400); }
  }
  document.addEventListener("click", function (e) {
    var s = e.target.closest("[data-show]"); if (!s) return;
    var h = s.getAttribute("data-show"), f = null;
    try { f = s.getAttribute("data-filter") ? JSON.parse(s.getAttribute("data-filter")) : null; } catch (err) { f = null; }
    if ($('.cf-it[data-h="' + h + '"]') || (client && f)) { e.preventDefault(); show(h, f); }
  });

  /* ---------- guide tabs (C3) ---------- */
  $$(".cf-tabs").forEach(function (tl) {
    var tabs = $$("[role=tab]", tl);
    function sel(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute("aria-selected", on ? "true" : "false"); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute("aria-controls")); if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { sel(t); });
      t.addEventListener("keydown", function (e) {
        var j = e.key === "ArrowRight" ? i + 1 : e.key === "ArrowLeft" ? i - 1 : e.key === "Home" ? 0 : e.key === "End" ? tabs.length - 1 : null;
        if (j === null) return; e.preventDefault(); sel(tabs[(j + tabs.length) % tabs.length], true);
      });
    });
  });

  /* ---------- quiz (C4): first rule whose answers match; unanswered = first option ---------- */
  $$(".cf-qz [data-quiz]").forEach(function (qz) {
    var qs = $$(".cf-qs[data-q]", qz), res = $$(".cf-res[data-when]", qz), wait = $(".cf-res.wait", qz), touched = false;
    function answers() {
      var a = {};
      qs.forEach(function (q) {
        var on = $(".op button[aria-pressed=true]", q) || $(".op button", q);
        a[q.getAttribute("data-q")] = on ? on.getAttribute("data-v") : "";
      });
      return a;
    }
    function run() {
      var a = answers(), hit = null;
      res.forEach(function (r) {
        if (hit) return;
        var w = {}; try { w = JSON.parse(r.getAttribute("data-when") || "{}"); } catch (e) { w = {}; }
        var ok = Object.keys(w).every(function (k) { return [].concat(w[k]).indexOf(a[k]) > -1; });
        if (ok) hit = r;
      });
      if (!hit) hit = res[res.length - 1];
      res.forEach(function (r) { r.hidden = r !== hit; });
      if (wait) wait.hidden = true;
    }
    qs.forEach(function (q) {
      $$(".op button", q).forEach(function (b) {
        b.addEventListener("click", function () {
          $$(".op button", q).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
          touched = true; run();
        });
      });
    });
  });

  /* ---------- v4 guide tiles (snippet cf-g4): one panel open at a time ---------- */
  var g4t = $$(".g4-tl");
  g4t.forEach(function (b) {
    b.addEventListener("click", function () {
      g4t.forEach(function (x) {
        var on = x === b; x.setAttribute("aria-expanded", on ? "true" : "false");
        var p = document.getElementById(x.getAttribute("aria-controls")); if (p) p.hidden = !on;
      });
      var p = document.getElementById(b.getAttribute("aria-controls"));
      if (p && p.getBoundingClientRect().top > window.innerHeight - 80) p.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  });

  /* ---------- v4 quiz dialog: every #quiz link opens it, a result link closes it (the #f= handler filters) ---------- */
  var qzm = $("dialog.g4-qzm");
  if (qzm && qzm.showModal) {
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href="#quiz"]');
      if (a) { e.preventDefault(); qzm.showModal(); return; }
      if (e.target.closest(".g4-qzx") || e.target === qzm) { qzm.close(); return; }
      if (e.target.closest('dialog.g4-qzm a[href^="#f="]')) qzm.close();
    }, true);
    if (location.hash === "#quiz") qzm.showModal();
  }


  // Tiles + En situation vary per visit: draw a photo per tile among same-kind photos, one product per tile when possible
  (function(){
    var sh=function(a){for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),x=a[i];a[i]=a[j];a[j]=x;}return a;};
    var taken={};
    document.querySelectorAll(".g4-tl").forEach(function(tl){
      var js=tl.querySelector(".g4-alt"),img=tl.querySelector("img");if(!js||!img)return;
      var alts;try{alts=sh(JSON.parse(js.textContent));}catch(e){return;}
      var c=alts.filter(function(a){return !taken[a.p];})[0]||alts[0];if(!c)return;
      taken[c.p]=1;img.removeAttribute("srcset");img.src=c.s;img.srcset=c.ss+", "+c.s+" 600w";
      var pn=document.getElementById(tl.getAttribute("aria-controls")),src=pn&&pn.querySelector(".g4-src");
      if(src){src.href=c.u;src.firstChild.nodeValue="Sur la photo : "+c.t;}
    });
    document.querySelectorAll(".g4-sit").forEach(function(row){
      sh([].slice.call(row.children)).forEach(function(el){row.appendChild(el);});
    });
  })();

  // Comparatif: both cards show the same design, a new random one every 4 s (paused on hover, off with reduced motion)
  (function(){
    var cards=[].slice.call(document.querySelectorAll(".g4-cc-im"));if(cards.length<2)return;
    var keys=function(c){return [].slice.call(c.querySelectorAll(".g4-cs")).map(function(a){return a.dataset.k;});};
    var k0=keys(cards[0]),k1=keys(cards[1]);
    var both=k0.filter(function(k){return k1.indexOf(k)>-1;}),pool=both.length>1?both:k0.concat(k1).filter(function(k,i,a){return a.indexOf(k)===i;});
    if(pool.length<2)return;
    for(var i=pool.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),x=pool[i];pool[i]=pool[j];pool[j]=x;}
    var at=0,hold=false;
    var show=function(k){cards.forEach(function(c){
      var sl=[].slice.call(c.querySelectorAll(".g4-cs")),t=sl.filter(function(a){return a.dataset.k===k;})[0];
      if(!t)t=sl[Math.floor(Math.random()*sl.length)];
      var img=t.querySelector("img");if(img)img.loading="eager";
      sl.forEach(function(a){var on=a===t;a.classList.toggle("on",on);if(on){a.removeAttribute("tabindex");a.removeAttribute("aria-hidden");}else{a.tabIndex=-1;a.setAttribute("aria-hidden","true");}});
    });};
    show(pool[0]);
    if(window.matchMedia("(prefers-reduced-motion: reduce)").matches)return;
    cards.forEach(function(c){c.addEventListener("mouseenter",function(){hold=true;});c.addEventListener("mouseleave",function(){hold=false;});});
    setInterval(function(){if(hold||document.hidden)return;at=(at+1)%pool.length;show(pool[at]);},4000);
  })();
  // Mobile carousel dots for En situation
  document.querySelectorAll(".g4-sit").forEach(function(row){
    var cards=row.querySelectorAll(".g4-sg");if(cards.length<2)return;
    var dots=document.createElement("div");dots.className="g4-sit-dots";dots.setAttribute("aria-hidden","true");
    cards.forEach(function(){dots.appendChild(document.createElement("span"));});
    row.after(dots);
    var upd=function(){var w=cards[0].offsetWidth+10,i=Math.round(row.scrollLeft/w);
      if(row.scrollLeft+row.clientWidth>=row.scrollWidth-4)i=cards.length-1;
      dots.querySelectorAll("span").forEach(function(d,k){d.classList.toggle("on",k===i);});};
    row.addEventListener("scroll",upd,{passive:true});upd();
  });
})();
